<template>
  <div ref="galeria" class="block block--white mt-3">
    <div class="container">
      <div class="row" style="margin-left:0px;margin-right:0px;">
        <!-- Mobile only: nome/descrição/texto acima do carrossel -->
        <div class="col-12 d-lg-none p-4">
          <div class="title">
            {{ name }}
          </div>
          <h3 class="description mt-3">
            {{ description }}
          </h3>
          <p class="more ml-5 mt-4">
            {{ text }}
          </p>
        </div>
        <div class="col-lg-4 order-lg-1 order-2">
          <div class="row">
            <div class="order-lg-1 order-3 mt-lg-0 mt-4 p-lg-0 p-4 d-none d-lg-block">
              <div class="title">
                {{ name }}
              </div>
              <h3 class="description mt-3">
                {{ description }}
              </h3>
              <p class="more ml-5 mt-4">
                {{ text }}
              </p>
            </div>
            <div class="order-lg-2 order-2 parts-top">
              <NavBarPartsModel
                :sessionActive="sessionArrayId"
                :parts="shoot"
                :thumb-photos="thumbPhotos"
                :translate="translate"
                :change-selected-tab="changeSelectedTab"
                :aguardando="aguardandoVersao"
                @changeSession="changeSessionPhotos"
                @showModalSubscribePlans="
                  emits('showModalSubscribePlans', (val: boolean) => val)
                "
              />
            </div>

          </div>
        </div>
        <div class="col-lg-8 order-lg-2 order-1 pad-left-5">
          <CarrosselModel
            :loadindSpinner="loadindSpinner"
            :images-model="photos"
            :name-model="name"
            :sessionLabel="sessionLabel"
            :current-image="currentImage"
            :slide-play="slidePlay"
            :seconds="secondsNormal"
            :key-down-events="keyDownEventsCarrousel"
            :zoomEnable="zoomEnable"
            :nextEnable="enableNextCarrossel"
            :prevEnable="enablePrevCarrossel"
            :image-alt-text="imageAltText"
            :nextLockedThumb="nextSectionInfo?.blocked ? nextSectionInfo.thumb : null"
            :nextBlocked="nextSectionInfo?.blocked ?? false"
            :prevBlocked="prevSectionInfo?.blocked ?? false"
            :offsetInPart="offsetInPart"
            :totalInPart="totalInPart"
            @showModalSubscribePlans="
              emits('showModalSubscribePlans', (val: boolean) => val)
            "
            @changeAutomatic="changeAutomaticCarrossel"
            @updateSlidePlay="updateSlidePlay"
            @updateCurrentImage="updateCurrentImage"
            @updateSeconds="updateSeconds"
            @showModalModelSlideShow="showModalModelSlideShow"
            @updateImageView="ChangeselectBellaCloudImg"
            @showModalPopupZoom="showZoomPopup = true"
          />
          
            <div class="row mb-4 mt-2 text-center row-actions" v-if="sessionLabel" style="margin-left:0px;margin-right:0px;">
              <div class="col-lg-3 col-5 mobile-section-active">
                <div class="session-title">
                  <div>
                    <b>{{ route.params.language == "pt-br" ? "Parte" : "Part" }} {{ partId + 1 }}</b> - {{ sessionLabel }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-3 mobile-sections">
                <div class="number-image" v-if="!isOnLockedSlide">
                  {{ offsetInPart + currentImage + 1 }} / {{ totalInPart }}
                </div>
              </div>
              <!--
              <div class="col-lg-5 col-2 btn-desktop">
                Super Zoom
              </div>
              -->
              <div class="col-lg-1 col-1 mrg-top-2 text-lg-center text-end">
                <img
                  :width="14"
                  :height="14"
                  :src="imgMaximize"
                  alt="Maximize"
                  class="cursor-pointer"
                  @click="showModalModelSlideShow(true)"
                />
              </div>
              <div
                class="col-lg-1 col-2 mobile-bellacloud d-flex justify-content-center"
                @click="showModalModelBellacloud(true)"
              >
                <font-awesome
                  :icon="['far', 'bookmark']"
                  size="md"
                  class="color-icon cursor-pointer"
                  style="margin-left: 5px;margin-top: 3px;"
                />
              </div>
              <div
                class="col-lg-1 col-1 mobile-share d-flex justify-content-center"
                @click="openShare()"
              >
                <font-awesome
                  :icon="['fas', 'share-nodes']"
                  size="md"
                  class="color-icon cursor-pointer"
                  style="margin-left: 5px;margin-top: 3px;"
                />
              </div>

              <div class="share-popup" v-if="showShare">
                <div>
                  <img class="cursor-pointer" :src="imgWhatsapp" alt="WhatsApp" width="50" @click="goToWhatsapp(name)"/>
                </div>
                <div class="share-close cursor-pointer" @click="closeShare()">
                  X
                </div>
                <div class="mt-3">
                  <input
                    class="share-input"
                    type="text"
                    :value="urlCopy"
                    readonly
                  />
                  <button
                    type="button"
                    class="share-button"
                    @click="copyToClipboard()"
                  >
                    {{ route.params.language == "pt-br" ? "Copiar" : "Copy" }}
                  </button>                    
                </div>
              </div>              
            </div>
            
        </div>
      </div>
    </div>
  </div>
  <!-- Modais só no navegador: abrem por interação e leem o store de usuário -->
  <ClientOnly>
  <ModalModelSlideShow
    @showModalSubscribePlans="
      emits('showModalSubscribePlans', (val: boolean) => val)
    "
    @showModalModelSlideShow="showModalModelSlideShow"
    @changeAutomatic="changeZoomAutomatic"
    @updateSeconds="updateSeconds"
    @changePhoto="changeNextorPrev"
    @changeSession="changeSessionPhotos"
    @updateSlidePlayZoom="updateSlidePlayZoom"
    :showSlide="showSlide"
    :imgSlide="imgSlide"
    :translate="translate"
    :key-down-events="keyDownEventsZoom"
    :total="totalPhoto - 1"
    :session="sessionArrayId"
    :loading="loadingZoom"
    :sessionLabel="sessionLabel"
    :seconds="secondsZoom"
    :partLabel="partId"
    :idxCurrent="currentImage"
    :slide-play-zoom="slidePlayZoom"
    :image-alt-text="imageAltText"
    :offsetInPart="offsetInPart"
    :totalInPart="totalInPart"
  />

  <ModalModelBellacloud
    @showModalModelBellacloud="showModalModelBellacloud"
    :showCloud="showCloud"
    :imageIdSelected="selectBellaCloudImg"
    :video="false"
  />
  <ModalModelParts
    @showModalModelParts="showModalModelParts"
    @changeSession="changeSessionPhotos"
    :showParts="showParts"
    :sessionActive="sessionArrayId"
    :change-selected-tab="changeSelectedTab"
    :parts="shoot"
    :translate="translate"
    @showModalSubscribePlans="
      emits('showModalSubscribePlans', (val: boolean) => val)
    "
  />
  <ModalPopupZoom
    :showModal="showZoomPopup"
    @close="showZoomPopup = false"
  />
  </ClientOnly>
</template>

<script lang="ts" setup>
import CarrosselModel from "./CarrosselModel.vue";
import NavBarPartsModel from "./NavBarPartsModel.vue";
import api from "@/api";
import ModalModelBellacloud from "@/components/Modais/ModalModelBellacloud.vue";
import ModalModelParts from "@/components/Modais/ModalModelParts.vue";
import ModalModelSlideShow from "@/components/Modais/ModalModelSlideShow.vue";
import ModalPopupZoom from "@/components/Modais/ModalPopupZoom.vue";
import translateModel from "@/tradutors/model";
import { isMobile } from "~/shared/utils/mobile";
import imgMaximize from "@/assets/img/maximize.png";
import imgWhatsapp from "@/assets/img/whatsappRed.png";
import {
  aguardarMudanca,
  photoGalleryTools,
  type ControleDaGaleria,
} from "@/composables/webmcp/tools.media";

const route = useRoute();
const translate = computed(() =>
  route.params.language == "pt-br"
    ? translateModel.portugues
    : translateModel.ingles
);

// `aguardandoVersao`: logado, a versão do usuário ainda não chegou (seções
// neutras, sem cadeado).
const props = defineProps(["model", "loadindSpinner", "photosModel", "aguardandoVersao"]);
const emits = defineEmits(["showModalSubscribePlans", "changeSelectdTab"]);
const secondsNormal = ref(3);
const secondsZoom = ref(3);
const name = computed(() => props.model.nameModel);
const imageAltText = computed(() => props.model.imageAltText);
const partId = ref(0);
const sessionArrayId = ref(0);
const currentImage = ref(0);
const description = computed(() => props.model.descriptionModel);
const text = computed(() => props.model.text);
const photos = ref(
  props.photosModel.shoot[partId.value].sessions[sessionArrayId.value].photos
);
const sessionLabel = ref(
  props.photosModel.shoot[partId.value].sessions[sessionArrayId.value].name
);
const sectionId = computed(
  () => props.photosModel.shoot[partId.value].sessions[sessionArrayId.value].sectionId
);
const shoot = computed(() => props.photosModel.shoot);
const loadingZoom = ref(true);
const selectBellaCloudImg = ref(
  props.photosModel.shoot[partId.value].sessions[sessionArrayId.value].photosId[
    currentImage.value
  ]
);
const thumbPhotos = computed(() => props.photosModel.firstPhotoSection);
const totalInPart = computed(() =>
  shoot.value[partId.value].sessions.reduce(
    (acc: number, s: any) => acc + (s.photosId?.length ?? 0),
    0
  )
);
const offsetInPart = computed(() =>
  shoot.value[partId.value].sessions
    .slice(0, sessionArrayId.value)
    .reduce((acc: number, s: any) => acc + (s.photosId?.length ?? 0), 0)
);
const zoomEnable = computed(() => props.photosModel.zoom);
const nextSectionInfo = computed(() => {
  let nextPart = partId.value;
  let nextSession = sessionArrayId.value + 1;

  // Tentar proxima session na mesma part
  if (nextSession >= shoot.value[nextPart].sessions.length) {
    // Tentar primeira session da proxima part
    nextPart = partId.value + 1;
    nextSession = 0;
    if (nextPart >= shoot.value.length) return null; // fim do ensaio
  }

  const session = shoot.value[nextPart].sessions[nextSession];
  return {
    blocked: session.block === 'true',
    thumb: thumbPhotos.value[nextPart]?.[nextSession] || null
  };
});
const prevSectionInfo = computed(() => {
  let prevPart = partId.value;
  let prevSession = sessionArrayId.value - 1;

  // Tentar session anterior na mesma part
  if (prevSession < 0) {
    // Tentar ultima session da part anterior
    prevPart = partId.value - 1;
    if (prevPart < 0) return null; // inicio do ensaio
    prevSession = shoot.value[prevPart].sessions.length - 1;
  }

  const session = shoot.value[prevPart].sessions[prevSession];
  return {
    blocked: session.block === 'true',
  };
});
const keyDownEventsCarrousel = ref(true);
const showCloud = ref(false);
const showParts = ref(false);
const showSlide = ref(false);
const imgSlide = ref("");
const keyDownEventsZoom = ref(false);
const slidePlay = ref(false);
const slidePlayZoom = ref(false);
const zoomPhotos = ref<any>([]);
const totalPhoto = ref(0);
const changeSelectedTab = ref<any>(0);
const photosId = ref<any>([]);
const urlCopy = computed(() => window.location.href);
const showShare = ref(false);
const showZoomPopup = ref(false);
const storeUser = userStore();
const isOnLockedSlide = computed(
  () =>
    !storeUser.isActiveUser &&
    !!nextSectionInfo.value?.blocked &&
    enableNextCarrossel.value === true &&
    currentImage.value >= photos.value.length
);

function showModalModelBellacloud(value: boolean) {
  if (value) {
    keyDownEventsCarrousel.value = false;
  } else {
    keyDownEventsCarrousel.value = true;
  }
  showCloud.value = value;
}
function showModalModelParts(value: boolean) {
  showParts.value = value;
}
async function showModalModelSlideShow(value: boolean) {
  if (!zoomEnable.value) {
    showZoomPopup.value = true
  } else {
    showSlide.value = value;
    imgSlide.value = "";
    if (value) {
      keyDownEventsCarrousel.value = false;
      keyDownEventsZoom.value = true;
      if (slidePlay.value) {
        slidePlay.value = false;
        slidePlayZoom.value = true;
      }
      loadingZoom.value = true;
      let body = document.getElementsByTagName("body");
      body[0].style.overflowY = "hidden";
      zoomPhotos.value = await getPhostosMaskZoom(
        sectionId.value,
        shoot.value[partId.value].sessions[sessionArrayId.value].photosId[
          currentImage.value
        ]
      );
      totalPhoto.value =
        shoot.value[partId.value].sessions[sessionArrayId.value].photosId.length;
      imgSlide.value = zoomPhotos.value[0];
      loadingZoom.value = false;
    } else {
      keyDownEventsCarrousel.value = true;
      keyDownEventsZoom.value = false;
      let body = document.getElementsByTagName("body");
      body[0].style.overflowY = "auto";
      if (slidePlayZoom.value) {
        slidePlay.value = true;
        slidePlayZoom.value = false;
      }
    }
  }
}
async function changeNextorPrev(change = 0) {
  loadingZoom.value = true;
  zoomPhotos.value = await getPhostosMaskZoom(
    sectionId.value,
    shoot.value[partId.value].sessions[sessionArrayId.value].photosId[change]
  );
  imgSlide.value = zoomPhotos.value[0];
  currentImage.value = change;
  loadingZoom.value = false;
}
async function changeSessionPhotos({
  part,
  session,
  next = true,
  zoom = null,
}: any) {
  photos.value = [];
  sessionLabel.value = "";
  sessionArrayId.value = session;
  if (shoot.value[part].sessions[session].photos && zoom == null)
    photos.value = shoot.value[part].sessions[session].photos;
  else
    photos.value = await getPhostosMask(
      shoot.value[part].sessions[session].sectionId
    );
  partId.value = part;
  sessionLabel.value = shoot.value[part].sessions[session].name;
  changeSelectedTab.value = partId.value;
  currentImage.value = zoom != null ? zoom : (next ? 0 : photos.value.length - 1);
}

async function changeZoomAutomatic(next = true) {
  let session = 0;
  if (showSlide.value) {
    if (next) {
      if (
        shoot.value[partId.value].sessions.length >
        sessionArrayId.value + 1
      ) {
        //Avança Seção
        loadingZoom.value = true;
        session = sessionArrayId.value + 1;
      } else if (
        shoot.value[partId.value].sessions.length - sessionArrayId.value == 1 &&
        shoot.value.length > partId.value + 1
      ) {
        //Avança Parte
        loadingZoom.value = true;
        session = 0;
        partId.value = partId.value + 1;
        changeSelectedTab.value = partId.value;
      } else if (shoot.value.length == partId.value + 1) {
        //Final do ensaio
        slidePlayZoom.value = false;
        return false;
      }
      loadingZoom.value = true;
      currentImage.value = 0;
      zoomPhotos.value = await getPhostosMaskZoom(
        shoot.value[partId.value].sessions[session].sectionId,
        shoot.value[partId.value].sessions[session].photosId[currentImage.value]
      );
      imgSlide.value = zoomPhotos.value[0];
      totalPhoto.value =
        shoot.value[partId.value].sessions[session].photosId.length;
      sessionArrayId.value = session;
      sessionLabel.value = shoot.value[partId.value].sessions[session].name;
      loadingZoom.value = false;
    } else {
      if (sessionArrayId.value > 0) {
        //Retrocede Seção
        loadingZoom.value = true;
        session = sessionArrayId.value - 1;
      } else if (sessionArrayId.value == 0 && partId.value > 0) {
        //Retrocede Parte
        loadingZoom.value = true;
        partId.value = partId.value - 1;
        session = shoot.value[partId.value].sessions.length - 1;
        changeSelectedTab.value = partId.value;
      } else if (sessionArrayId.value == 0 && partId.value == 0) {
        //Final do ensaio
        return false;
      }
      let ultimoIndice =
        shoot.value[partId.value].sessions[session].photosId.length;
      loadingZoom.value = true;
      zoomPhotos.value = await getPhostosMaskZoom(
        shoot.value[partId.value].sessions[session].sectionId,
        shoot.value[partId.value].sessions[session].photosId[ultimoIndice - 1]
      );
      imgSlide.value = zoomPhotos.value[0];
      totalPhoto.value =
        shoot.value[partId.value].sessions[session].photosId.length;
      sessionArrayId.value = session;
      sessionLabel.value = shoot.value[partId.value].sessions[session].name;
      currentImage.value = ultimoIndice - 1;
      loadingZoom.value = false;
    }
  }
}
const enableNextCarrossel = computed(() => {
  if (shoot.value[partId.value].sessions.length > sessionArrayId.value + 1) {
    //Avança Seção
    return true;
  } else if (
    shoot.value[partId.value].sessions.length - sessionArrayId.value == 1 &&
    shoot.value.length > partId.value + 1
  ) {
    return true;
  } else if (shoot.value.length == partId.value + 1) {
    return false;
  }
});

const enablePrevCarrossel = computed(() => {
  if (sessionArrayId.value > 0) {
    //Retrocede Seção
    return true;
  } else if (sessionArrayId.value == 0 && partId.value > 0) {
    //Retrocede Parte
    return true;
  } else if (sessionArrayId.value == 0 && partId.value == 0) {
    //Final do ensaio
    return false;
  }

  return false;
});
async function changeAutomaticCarrossel(next = true) {
  if (next) {
    if (shoot.value[partId.value].sessions.length > sessionArrayId.value + 1) {
      //Avança Seção
      changeSessionPhotos({
        part: partId.value,
        session: ++sessionArrayId.value,
        next: true,
      });
    } else if (
      shoot.value[partId.value].sessions.length - sessionArrayId.value == 1 &&
      shoot.value.length > partId.value + 1
    ) {
      //Avança Parte
      sessionArrayId.value = 9999;
      changeSessionPhotos({
        part: ++partId.value,
        session: 0,
        next: true,
      });
      changeSelectedTab.value = partId.value;
    } else if (shoot.value.length == partId.value + 1) {
      //fim do ensaio
      slidePlay.value = false;
    }
  } else {
    if (sessionArrayId.value > 0) {
      //Retrocede Seção
      changeSessionPhotos({
        part: partId.value,
        session: --sessionArrayId.value,
        next: false,
      });
    } else if (sessionArrayId.value == 0 && partId.value > 0) {
      //Retrocede Parte
      sessionArrayId.value = 9999;
      changeSessionPhotos({
        part: --partId.value,
        session: shoot.value[partId.value].sessions.length - 1,
        next: false,
      });
      changeSelectedTab.value = partId.value;
    }
  }
}
async function getPhostosMask(id: number, zoom = 0) {
  return api
    .get("v1/modelos/fernanda-campos/section/" + id + "?grande=" + zoom)
    .then(({ data }) => {
      photosId.value = data.photosId;
      return data.photos;
    });
}
async function getPhostosMaskZoom(id: number, photoIdTemp: any) {
  return api
    .get(
      "v1/modelos/fernanda-campos/section/" +
        id +
        `/photo/${photoIdTemp}` +
        "?grande=1"
    )
    .then(({ data }) => {
      photosId.value = data.photosId;
      return data.photos;
    });
}
function updateSlidePlay(value: boolean) {
  slidePlay.value = value;
}
function updateSlidePlayZoom(value: boolean) {
  slidePlayZoom.value = value;
}
function updateCurrentImage(value: number) {
  currentImage.value = value;
}
function updateSeconds(value: number) {
  secondsNormal.value = value;
  secondsZoom.value = value;
}
async function ChangeselectBellaCloudImg(val: number) {
  if (shoot.value[partId.value]?.sessions[sessionArrayId.value]?.photosId)
    selectBellaCloudImg.value =
      shoot.value[partId.value]?.sessions[sessionArrayId.value]?.photosId[
        val - 1
      ] ?? 1;
  else if (photosId.value.length)
    selectBellaCloudImg.value = photosId.value[val - 1];
}
onMounted(() => {
  if (route.query.part && 
      route.query.part !== '' && 
      Number(route.query.part) > 0 && 
      ( (Number(route.query.part) - 1) < shoot.value.length)
     ) 
  {
    changeSessionPhotos({
      part: Number(route.query.part)-1,
      session: 0,
      next: true,
    });
  }
});

function openShare() {
  showShare.value = true;
}

function closeShare() {
  showShare.value = false;
}

function goToWhatsapp(name: string) {
  const url = window.location.href;
  const text = route.params.language == "pt-br" ? " - Ensaio Exclusivo no Bella da Semana  " : "Exclusive shoot on Bella Club";
  window.open("https://api.whatsapp.com/send?text=" + name + text + url);
}

function copyToClipboard() {
  const url = window.location.href;
  navigator.clipboard.writeText(url).then(() => {
    alert(route.params.language == "pt-br" ? "Link copiado para a área de transferência!" : "Link copied to clipboard!");
  });
}

// WebMCP: navigate_photos e photo_slideshow, vivas só enquanto o ensaio estiver
// na tela. Passam as fotos pelos mesmos botões do carrossel que as setas do
// teclado e o slideshow usam, então seção bloqueada e fim de ensaio seguem as
// regras de sempre. Onde a tela abriria a janela de planos, a tool para antes
// e só avisa o agente.
const galeria = ref<HTMLElement | null>(null);
const botaoDoCarrossel = (lado: "next" | "prev") =>
  galeria.value?.querySelector<HTMLElement>(`.carousel__${lado}`) ?? null;
const posicaoNaGaleria = () =>
  `${partId.value}/${sessionArrayId.value}/${currentImage.value}/${photos.value.length}`;
const proximaSecaoTravada = () =>
  !storeUser.isActiveUser && Boolean(nextSectionInfo.value?.blocked);
const secaoAnteriorTravada = () =>
  !storeUser.isActiveUser && Boolean(prevSectionInfo.value?.blocked);

const controleDaGaleria: ControleDaGaleria = {
  estado: () => ({
    parte: partId.value,
    partes: shoot.value.map((parte: any) => String(parte.name ?? "")),
    secao: String(sessionLabel.value ?? ""),
    foto:
      offsetInPart.value +
      Math.min(currentImage.value, Math.max(photos.value.length - 1, 0)) +
      1,
    totalNaParte: totalInPart.value,
    travada: isOnLockedSlide.value,
    slideshow: Boolean(slidePlay.value),
    segundos: secondsNormal.value,
  }),
  async proxima() {
    const naUltima = currentImage.value >= photos.value.length - 1;
    if (naUltima && !enableNextCarrossel.value) return "fim";
    if (naUltima && proximaSecaoTravada()) return "travada";
    botaoDoCarrossel("next")?.click();
    await aguardarMudanca(posicaoNaGaleria);
    // Depois da última foto o carrossel para num slide de passagem ("próxima
    // seção"); o segundo clique, como o da pessoa, entra na seção seguinte.
    if (currentImage.value >= photos.value.length && enableNextCarrossel.value) {
      botaoDoCarrossel("next")?.click();
      await aguardarMudanca(posicaoNaGaleria, 3000);
    }
    return "ok";
  },
  async anterior() {
    const naPrimeira = currentImage.value <= 0;
    if (naPrimeira && !enablePrevCarrossel.value) return "inicio";
    if (naPrimeira && secaoAnteriorTravada()) return "travada";
    botaoDoCarrossel("prev")?.click();
    await aguardarMudanca(posicaoNaGaleria, 3000);
    return "ok";
  },
  async irParaParte(indice) {
    const parte = shoot.value[indice];
    if (!parte) return "parte-inexistente";
    if (parte.sessions?.[0]?.block === "true" && !storeUser.isActiveUser) {
      return "travada";
    }
    await changeSessionPhotos({ part: indice, session: 0, next: true });
    return "ok";
  },
  async slideshow(ligar, segundos) {
    if (segundos) updateSeconds(segundos);
    if (!ligar) {
      slidePlay.value = false;
      return;
    }
    // Já ligado: desliga e liga, para o carrossel recomeçar com o intervalo novo.
    if (slidePlay.value) {
      slidePlay.value = false;
      await nextTick();
    }
    slidePlay.value = true;
  },
};
useWebMcpTools((ctx) => photoGalleryTools(ctx, controleDaGaleria));
</script>

<style scoped lang="css">
.block {
  padding: 25px 0;
}

.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
  text-transform: uppercase;
  margin-top: 2px;
}

.description {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.spin-load {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  color: #b20000;
}

.more {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.btn-outline-dark {
  font-family: "Exo-2";
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  box-sizing: border-box;
  height: 40px;
  width: 84px;
  border: 1px solid #5b5858;
  border-radius: 25px;
}

.btn-outline-secondary {
  font-family: "Exo-2";
  font-size: 14px;
  letter-spacing: 0;
  border-radius: 25px;
  border: none;
}

.btn-outline-secondary:hover {
  background-color: #f2f2f2;
  color: #5b5858;
}

.mobile-section-active,
.mobile-sections,
.btn-mobile {
  color: #444444;
  font-size: 14px;
  display: none;
}

.mobile-sections,
.mobile-share,
.mobile-bellacloud {
  float: right;
}

.mobile-share > .fa-share-nodes {
  display: none;
}

.pad-left-5 {
  padding-left: 3rem !important;
}

.mrg-top-2 {
  margin-top: -4px !important;
}

.number-image {
  display: none;
}

.color-icon {
  color: #5b5858;
}

.parts-top{
  margin-top: 3rem;
}

.share-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  top: 35px;
  z-index: 10;
  width: 350px;
  padding: 20px;
}

.share-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  margin-right: 10px;
  width: 220px;
}

.share-button {
  font-weight: 500;
  background-color: black !important;
  border: 1px solid black !important;
  border-radius: 30px !important;
  color: white;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  height: 43px;
  padding: 0px 10px;
}

.share-close {
  position: absolute;
  top: 3px;
  right: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #888;
  z-index: 11;
  cursor: pointer;
}

.row-actions {
  justify-content: center;
  left: 160px;
}

/* Tablet/iPad (770–1199px): o deslocamento left:160px (pensado para o desktop
   largo) joga a barra de ações para fora da .col-lg-8 e gera overflow horizontal
   na página. Como html/.slot-body são overflow-x:visible, esse overflow alarga o
   bloco-contêiner inicial e desloca o header fixed (corta "Assine"/MENU no iPad).
   Alinhar a barra ao carrossel, como já é feito no mobile (left:0). */
@media screen and (min-width: 770px) and (max-width: 1199px) {
  .row-actions {
    left: 0;
  }
}

@media (min-width: 769px) {
  .text {
    display: block;
    color: #fff;
    max-width: 350px;
  }
}

/* regras mobile 992vp */
@media screen and (max-width: 992px) {
  .block {
    padding: 0px 0;
    margin-top: 0 !important;
  }

  .btn-desktop {
    display: none;
  }

  .btn-outline-dark {
    padding-right: 15px !important;
    padding-left: 15px !important;
    font-size: 14px;
    width: unset;
  }

  .mobile-section-active,
  .mobile-sections {
    display: block;
  }

  .mobile-share > .fa-share-nodes {
    display: block;
    float: center;
  }

  .container {
    padding: 0px 0px;
  }

  .pad-left-5 {
    padding-left: 0rem !important;
  }

  .session-title {
    font-family: "Roboto-Regular";
    font-size: 14px;
  }

  .fa-table-cells-large {
    top: -3px;
  }

  .number-image {
    display: block;
    font-size: 13px;
    top: 1px;
  }

  .color-icon {
    color: #5b5858;
  }
  .parts-top{
    margin-top: 25px;
  }  

  .share-popup {
    width: 90%;
    right: 10px;
    top: 35px;
  }  

  .share-input {
    width: 200px; 
  }
  .title {
    font-size: 35px;
    line-height: 40px;
  } 
  .description {
    font-size: 20px;
  }
  .more {
    font-size: 14px;
  }
  .row-actions {
    left: 0;
  }
}
</style>
